import { render } from "./BuyingPage.vue?vue&type=template&id=2360e961&scoped=true"
import script from "./BuyingPage.vue?vue&type=script&lang=js"
export * from "./BuyingPage.vue?vue&type=script&lang=js"

import "./BuyingPage.vue?vue&type=style&index=0&id=2360e961&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2360e961"]])

export default __exports__